document.querySelectorAll('[data-tabs]').forEach((tabs) => {
    const triggers = Array.from(tabs.querySelectorAll('.TabsTrigger'));
    const panels = Array.from(tabs.querySelectorAll('.TabsPanel'));

    if (!triggers.length || !panels.length) {
        return;
    }

    function setActiveTab(activeIndex) {
        triggers.forEach((trigger, index) => {
            const isActive = index === activeIndex;
            trigger.classList.toggle('__active', isActive);
            trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
            trigger.setAttribute('tabindex', '0');
        });

        panels.forEach((panel, index) => {
            const isActive = index === activeIndex;
            panel.classList.toggle('__active', isActive);
            panel.hidden = !isActive;
        });
    }

    triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
            setActiveTab(index);
        });

        trigger.addEventListener('keydown', (event) => {
            let nextIndex = null;

            if (event.key === 'ArrowRight') {
                nextIndex = (index + 1) % triggers.length;
            } else if (event.key === 'ArrowLeft') {
                nextIndex = (index - 1 + triggers.length) % triggers.length;
            } else if (event.key === 'Home') {
                nextIndex = 0;
            } else if (event.key === 'End') {
                nextIndex = triggers.length - 1;
            }

            if (nextIndex === null) {
                return;
            }

            event.preventDefault();
            setActiveTab(nextIndex);
            triggers[nextIndex].focus();
        });
    });

    const initialIndex = triggers.findIndex((trigger) => trigger.getAttribute('aria-selected') === 'true');
    setActiveTab(Math.max(initialIndex, 0));
});
